import Axios, { AxiosError } from 'axios';

import store from '../store/store';
import i18n from '../i18n';
import { getApiErrorMessage } from '../constants/errorMessages';
import { API_URL } from '../constants/env';

const omitErrorRoutes: readonly string[] = ['/Auth/restore-password'];

const AdacaAPI = Axios.create({
  baseURL: API_URL,
});

AdacaAPI.interceptors.request.use((config) => {
  // Para usos futuros, se puede agregar la autorización aquí si es necesario.
  return config;
});

AdacaAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    const t = i18n.getFixedT(i18n.language || 'es');
    if (error.config && error.config.url && omitErrorRoutes.includes(error.config.url)) {
      return Promise.reject(error);
    } else if (typeof error?.response?.data === 'string') {
      store.dispatch({
        type: 'general/showToast',
        payload: { message: getApiErrorMessage(t, error?.response?.data), severity: 'error', open: true },
      });
    }
    return Promise.reject(error);
  },
);

export default AdacaAPI;
